const EditLicenseStyle = (theme) => ({
    licenseLog: {
        paddingRight: 20,
        marginTop: 20
    }
});

export default EditLicenseStyle;